const getLabelByValue = (value, options) => {
  return options.find((option) => option.value === value)?.label;
};

const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
};

const isBlank = (value) => !value?.trim();

const decodeEncodedFileSegment = (segment) => {
  let decoded = String(segment).replace(/\+/g, " ");
  for (let i = 0; i < 3; i += 1) {
    if (!/%[0-9A-Fa-f]{2}/.test(decoded)) break;
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch {
      decoded = decoded.replace(/%([0-9A-Fa-f]{2})/g, (_, hex) =>
        String.fromCharCode(parseInt(hex, 16)),
      );
      break;
    }
  }
  return decoded;
};

const getFileBaseName = (url) => {
  if (url == null || url === "") return "";
  let segment = String(url).split("?")[0];
  try {
    const parsed = new URL(
      segment.includes("://")
        ? segment
        : `https://placeholder.local/${segment.replace(/^\//, "")}`,
    );
    segment = parsed.pathname.split("/").pop() || segment;
  } catch {
    segment = segment.split("/").pop() || segment;
  }
  return decodeEncodedFileSegment(segment);
};

export { getLabelByValue, isValidEmail, isBlank, getFileBaseName };
